import React, { PropsWithChildren } from "react";

interface Props {
  to: string;
}

const FooterSocialLink = ({ to, children }: PropsWithChildren<Props>) => {
  return (
    <a
      href={to}
      className="w-[30px] h-[30px] bg-white hover:bg-grey-medium-3 rounded-full flex items-center justify-center"
    >
      {children}
    </a>
  );
};

export default FooterSocialLink;
